import apiClient, { getWithDedupe } from './client'

import type { PaginatedResponse, ProjectChangelogEntry, ProjectChangelogEntryInput } from '@/types/gia'

export interface ChangelogFilters {
  page?: number
  page_size?: number
  q?: string
  category?: string
  impact?: string
  visible_to_management?: boolean
  date_from?: string
  date_to?: string
}

const normalizeFilters = (filters: ChangelogFilters) => ({
  ...filters,
  visible_to_management:
    filters.visible_to_management === undefined
      ? undefined
      : filters.visible_to_management ? '1' : '0'
})

const changelogApi = {
  list: async (filters: ChangelogFilters = {}): Promise<PaginatedResponse<ProjectChangelogEntry>> => {
    return getWithDedupe<PaginatedResponse<ProjectChangelogEntry>>('/changelog/', {
      params: normalizeFilters(filters)
    })
  },

  create: async (data: ProjectChangelogEntryInput): Promise<ProjectChangelogEntry> => {
    const response = await apiClient.post<ProjectChangelogEntry>('/changelog/', data)

    return response.data
  },

  update: async (id: number, data: Partial<ProjectChangelogEntryInput>): Promise<ProjectChangelogEntry> => {
    const response = await apiClient.patch<ProjectChangelogEntry>(`/changelog/${id}/`, data)

    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/changelog/${id}/`)
  }
}

export default changelogApi
